export class ErrorNotFound extends Error {

}
